import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

import { TableSection } from '../styles';
import { OperationFlow } from './components/OperationFlow';
import { RequestList } from './components/RequestList';
import { RequestView } from './types';

export function NoticeDetailsRequest(): JSX.Element {
  // View (list/flow) lives in the URL to survive returning.
  const [searchParams, setSearchParams] = useSearchParams();
  const view: RequestView =
    searchParams.get('view') === 'operation-flow' ? 'operation-flow' : 'list';

  const handleViewChange = (
    event: React.MouseEvent<HTMLElement>,
    newView: RequestView | null
  ): void => {
    if (!newView) return;
    // Each view has its own list, and the operation flow has no search.
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set('view', newView);
      next.delete('page');
      next.delete('search');
      return next;
    });
  };

  return (
    <TableSection>
      <Typography color="common.grey" fontSize={21} fontWeight={600} my={3}>
        Pedidos de credenciamento
      </Typography>
      <ToggleButtonGroup
        value={view}
        exclusive
        onChange={handleViewChange}
        size="small"
        color="secondary"
        sx={{ mb: 2 }}
      >
        <ToggleButton value="list" sx={{ textTransform: 'none' }}>
          Lista
        </ToggleButton>
        <ToggleButton value="operation-flow" sx={{ textTransform: 'none' }}>
          Fluxo de Operação
        </ToggleButton>
      </ToggleButtonGroup>
      {view === 'list' ? <RequestList /> : <OperationFlow />}
    </TableSection>
  );
}
